import CrossMath from "../../views/crossMath"
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export function CrossMathGridSelection() {
    return <>
     <FormLabel id="cross-math-grid-row-radio-buttons-group-label">Grid Size</FormLabel>
      <RadioGroup
        row
        aria-labelledby="cross-math-grid-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        <FormControlLabel value="3" control={<Radio />} label="3 X 3" />
        <FormControlLabel value="4" control={<Radio />} label="4 X 4" />
        <FormControlLabel value="5" control={<Radio />} label="5 X 5" />
      </RadioGroup>
    </>
}

export function CrossMathInput() {
    return <>
        <CrossMath />
    </>
}